import { toast } from 'react-toastify';
import { DropdownDivider, DropdownItem, DropdownLabel } from '@accure/ui';
import { RotateCcw } from 'lucide-react';

import { GlobalResetDemo } from '@/api/fe-api/view/mutations/global-reset-demo';
import { useMe } from '@/hooks/use-me';
import { cls } from '@/utils/cls';

export function ResetScenarioMenuItem() {
  const me = useMe();
  const resetDemo = GlobalResetDemo.useMutation();

  async function handleResetDemo() {
    if (
      !window.confirm(
        'Do you really want to reset the demo scenario? This will reset all demo data.',
      )
    ) {
      return;
    }

    toast.promise(resetDemo.mutateAsync(), {
      success: 'Demo scenario reset successfully',
      pending: 'Resetting demo scenario...',
      error: 'Failed to reset demo scenario',
    });
  }

  // Only show for users with config ID '49'
  if (me.config.id !== '49') {
    return null;
  }

  return (
    <>
      <DropdownDivider />
      <DropdownItem
        className="hover:bg-zinc-950/10"
        onClick={handleResetDemo}
        data-testid="reset-scenario-menu-item"
      >
        <RotateCcw
          data-slot="icon"
          className={cls('animate', { 'animate-spin': resetDemo.isLoading })}
        />
        <DropdownLabel>Reset Demo Scenario</DropdownLabel>
      </DropdownItem>
    </>
  );
}
